import styled from 'styled-components';
import {SIZES} from '@fupa/fupa-uikit';

const FederatedProviderPlaceholder = styled.div`
  visibility: hidden;
  height: ${SIZES['36']};
`;

export default FederatedProviderPlaceholder;
